import type { SiteSettings } from '@brix/types'

export interface SiteProps {
  id: string
  tenantId: string
  name: string
  subdomain: string
  customDomain: string | null
  published: boolean
  settings: SiteSettings
  createdAt: Date
  updatedAt: Date
}

export class Site {
  readonly id: string
  readonly tenantId: string
  readonly name: string
  readonly subdomain: string
  readonly customDomain: string | null
  readonly published: boolean
  readonly settings: SiteSettings
  readonly createdAt: Date
  readonly updatedAt: Date

  private constructor(props: SiteProps) {
    this.id = props.id
    this.tenantId = props.tenantId
    this.name = props.name
    this.subdomain = props.subdomain
    this.customDomain = props.customDomain
    this.published = props.published
    this.settings = props.settings
    this.createdAt = props.createdAt
    this.updatedAt = props.updatedAt
  }

  static reconstitute(props: SiteProps): Site {
    return new Site(props)
  }

  get url(): string {
    return this.customDomain
      ? `https://${this.customDomain}`
      : `https://${this.subdomain}.brix.app`
  }

  withPublished(published: boolean): Site {
    return new Site({ ...this, published })
  }

  withSettings(patch: Partial<SiteSettings>): Site {
    return new Site({ ...this, settings: { ...this.settings, ...patch } })
  }
}
